import { render, staticRenderFns } from "./discount-edit.vue?vue&type=template&id=5ba84991&scoped=true"
import script from "./discount-edit.vue?vue&type=script&lang=js"
export * from "./discount-edit.vue?vue&type=script&lang=js"
import style0 from "./discount-edit.vue?vue&type=style&index=0&id=5ba84991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba84991",
  null
  
)

export default component.exports